import { TextSkeleton } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function DocumentsPageHeaderSkeleton() {
  return (
    <Stack spacing={3} alignItems="center">
      <TextSkeleton variant="h4" width="90%" />
      <TextSkeleton variant="body2" width="100%" />
    </Stack>
  );
}
